<template>
  <div class="page-layout">
    <div class="pt-5 curated-shell">
      <appHeader :searchFilter="searchFilter"></appHeader>
      <transition appear name="fade">
        <div class="container-fluid px-3 shop">

          <!-- ── Curated nav tabs (matches Shop.vue design exactly) ── -->
          <div class="row pb-2" v-if="curatedItems.length > 0">
            <div class="col-md-12">
              <nav
                class="curated-nav"
                :style="{ background: bgColorCode ? (bgColorCode.startsWith('#') ? bgColorCode : '#' + bgColorCode) : '#312589' }"
              >
                <div class="curated-nav__inner">
                  <ul class="curated-list">
                    <li v-for="item in curatedItems" :key="item.id">
                      <a
                        href="javascript:void(0)"
                        class="curated-tab"
                        :class="{ 'curated-tab--active': item.id == currentCuratedItemId }"
                        @click="$router.push({ path: '/curated-items', query: { id: item.id } })"
                      >
                        {{ item.title }}
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>

          <!-- ── Product grid ── -->
          <div class="row pt-3 pb-5">
            <div class="col-12">

              <!-- Loading spinner -->
              <div v-if="isLoading" class="curated-spinner">
                <div class="spinner-ring"></div>
              </div>

              <!-- Products -->
              <div v-else-if="curatedProducts.length > 0" class="curated-product-grid">
                <a
                  v-for="product in curatedProducts"
                  :key="product.product_id"
                  :href="'/shop/product/1/' + product.product_id"
                  target="_blank"
                  class="product-card"
                >
                  <div class="image">
                    <img :src="product.image_url" class="img-fluid" />
                    <div class="product-overlay">
                      <span class="view-label">View Product</span>
                    </div>
                  </div>
                  <div class="product-body">
                    <p class="name">{{ product.name }}</p>
                  </div>
                </a>
              </div>

              <!-- Empty state -->
              <div v-else class="curated-empty">
                <span class="curated-empty__icon">🔍</span>
                <p class="curated-empty__text">No products found in this collection.</p>
              </div>

            </div>
          </div>

        </div>
      </transition>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { isMobile, isTablet } from "mobile-device-detect";
import { mapState } from "vuex";
import FrontendService from "../../services/FrontendService"

export default {
  computed: {
    currentCuratedItemId () {
      return this.$route.query.id
    }
  },
  data() {
    return {
      curatedItems: [],
      curatedProducts: [],
      bgColorCode: "#312589",
      isLoading: false,
    };
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
  },
  methods: {
    getCuratedItems() {
        let data = {
        }
        FrontendService.getCuratedItems(data)
        .then((response) => {
            if (response.status != 200) {
                //alert(response.data.error)
            } else {
                this.curatedItems = response.data;
            }
        }).catch((e) => {
          alert(e.response.data.message);
        });
    },
    getCuratedItemProducts() {
        this.curatedProducts = [];
        this.isLoading = true;
        let data = {
          id: this.currentCuratedItemId
        }
        FrontendService.getCuratedItemProducts(data)
        .then((response) => {
            if (response.status != 200) {
                //alert(response.data.error)
            } else {
                this.curatedProducts = response.data.products;
            }
        }).catch((e) => {
          alert(e.response.data.message);
        }).finally(() => {
          this.isLoading = false;
        });   
    },
    getCatalogGridsForUser() {
        FrontendService.getCatalogGridsForUser({})
        .then((response) => {
            if (response.status === 200) {
                this.bgColorCode = response.data.customize_grid_layout_bg_color || "#312589";
            }
        }).catch(() => {});
    },
  },
  watch: {
    currentCuratedItemId() {
      this.getCuratedItemProducts();    
    }
  },
  beforeMount() {
    this.getCuratedItems();
    this.getCuratedItemProducts();
    this.getCatalogGridsForUser();
  }

};
</script>

<style lang="scss" scoped>
/* curated-shell background */
.curated-shell {
  background: #f7f8fc;
}

/* ── Fade transition ── */
.fade-enter-active { transition: opacity 0.4s ease; }
.fade-enter        { opacity: 0; }

/* ═══════════════════════════════════════════
   CURATED NAV  (identical to Shop.vue)
═══════════════════════════════════════════ */
.curated-nav {
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 4px;
}

.curated-nav__inner {
  background: rgba(0, 0, 0, 0.28);
  padding: 10px 14px;
  display: flex;
  align-items: center;
}

.curated-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}

.curated-tab {
  display: inline-flex;
  align-items: center;
  padding: 9px 22px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-decoration: none;
  border-radius: 50px;
  border: 2px solid rgba(255, 255, 255, 0.55);
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(4px);
  transition: all 0.2s ease;
  cursor: pointer;
  white-space: nowrap;
  text-shadow: 0 1px 3px rgba(0,0,0,0.4);

  &:hover {
    background: rgba(255, 255, 255, 0.28);
    border-color: #fff;
    color: #fff;
    text-decoration: none;
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
  }

  &--active {
    background: #ffffff;
    border-color: #ffffff;
    color: #1a1a1a;
    font-weight: 700;
    text-shadow: none;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);

    &:hover {
      color: #1a1a1a;
      background: #f0f0f0;
      transform: translateY(-1px);
    }
  }
}

/* ═══════════════════════════════════════════
   PRODUCT GRID
═══════════════════════════════════════════ */
.curated-product-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (max-width: 992px)  { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 768px)  { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 480px)  { grid-template-columns: repeat(2, 1fr); gap: 10px; }
}

/* ── Product card (matches Shop.vue ProductGrid) ── */
.product-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #eaecf4;
  border-radius: 14px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.25s, transform 0.25s;

  &:hover {
    box-shadow: 0 8px 28px rgba(0,0,0,0.12);
    transform: translateY(-3px);
    text-decoration: none;
    color: inherit;
  }

  .image {
    position: relative;
    overflow: hidden;
    background: #f4f5f9;
    height: 200px;

    @media (max-width: 480px) { height: 150px; }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 12px;
      transition: transform 0.35s ease;
    }
  }

  &:hover .image img { transform: scale(1.04); }

  .product-overlay {
    position: absolute;
    inset: 0;
    background: rgba(79,110,247,0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.25s;

    .view-label {
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.5px;
      border: 2px solid rgba(255,255,255,0.7);
      padding: 6px 18px;
      border-radius: 20px;
    }
  }

  &:hover .product-overlay { opacity: 1; }

  .product-body {
    padding: 12px 14px 14px;
  }

  .name {
    font-size: 13.5px;
    font-weight: 500;
    color: #2d3142;
    margin: 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

/* ═══════════════════════════════════════════
   LOADING SPINNER
═══════════════════════════════════════════ */
.curated-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

.spinner-ring {
  width: 40px;
  height: 40px;
  border: 3px solid #e8eaf0;
  border-top-color: #4f6ef7;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ═══════════════════════════════════════════
   EMPTY STATE
═══════════════════════════════════════════ */
.curated-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  gap: 12px;

  &__icon { font-size: 48px; }

  &__text {
    font-size: 15px;
    color: #aab0c6;
    margin: 0;
    text-align: center;
  }
}
</style>

<!-- Global (non-scoped) styles so the flex layout reaches the child footer component -->
<style lang="scss">
/* Sticky footer for CuratedItems page */
.page-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  /* curated-shell flex-grows; footer stays at bottom */
  .curated-shell {
    flex: 1 0 auto;
  }

  /* target footer-desktop / footer-mobile rendered by appFooter child */
  .footer-desktop,
  .footer-mobile {
    flex-shrink: 0;
  }
}
</style>